import React from "react";
import values from "../../values";
import Context from "../../context";
import { Components } from "./Components";

import {
  BreadCrumb,
  CustomLeafLetArea,
  CustomView,
  Pagination,
  TableHeader,
  TableLoading,
} from "../../components";

import "./index.sass";

const ClientScreen = () => {
  const { requestWorkTime, setRequestWorkTime, resultWorkTime } =
    React.useContext(Context.WorkTimeScreen);

  return (
    <CustomView.Container id="work-time-screen-container">
      <CustomView.Row className="table-options-wrapper">
        <CustomView.Column
          extraLarge={3}
          large={5}
          medium={5}
          className="bread-crumb-wrapper"
        >
          <BreadCrumb />
        </CustomView.Column>
        <CustomView.Column
          extraLarge={4}
          large={5}
          medium={7}
          className="search-and-filter-wrapper"
        >
          <Components.Create />

          {/* <Components.Filter /> */}
          {/* <Components.Search /> */}
        </CustomView.Column>
      </CustomView.Row>
      <div className="table-content-wrapper">
        {resultWorkTime?.status === "loading" ? (
          <TableLoading />
        ) : (
          <Components.Body data={resultWorkTime?.data?.result?.docs} />
        )}
      </div>

      {resultWorkTime?.status === "success" &&
        resultWorkTime?.data?.result?.totalDocs >
          values.constants.PANEL_TABLE_DEFAULT_LIMIT && (
          <div className="pagination">
            <Pagination
              page={requestWorkTime?.page}
              totalPages={resultWorkTime?.data?.result?.totalPages}
              onPaginate={(page: number) =>
                setRequestWorkTime!({ ...requestWorkTime, page })
              }
            />
          </div>
        )}
      <Components.Update />
      <Components.Delete />
    </CustomView.Container>
  );
};

export default ClientScreen;
